const languages = [
  {
    langCode: "en",
    langDisplay: "English",
    langName: "English",
    welcomeMessage:
      "The Ministry of Housing and Urban Affairs (MoHUA), Government of India, is implementing a year-round citizen feedback mechanism covering all urban cities across the country. A key objective of this initiative is to gather your feedback on the progress made by your city in improving cleanliness and sanitation, particularly in your neighbourhood. On behalf of the Ministry, we sincerely appreciate the time and effort you take to share your views. Your valuable inputs will play an important role in strengthening urban cleanliness initiatives and driving continuous improvement.",
    mlanguageId: 1,
    deleted: false
  },
  {
    langCode: "hi",
    langDisplay: "हिंदी",
    langName: "Hindi",
    welcomeMessage:
      "भारत सरकार की हाउसिंग एंड अर्बन अफेयर्स मिनिस्ट्री (MoHUA) द्वारा पूरे देश के सभी शहरी क्षेत्रों में साल भर चलने वाला सिटीज़न फ़ीडबैक सिस्टम लागू किया जा रहा है। इस पहल का मुख्य उद्देश्य आपके शहर में स्वच्छता और सफाई में हुए सुधार, विशेष रूप से आपके मोहल्ले में, के बारे में आपकी प्रतिक्रिया प्राप्त करना है।मिनिस्‍ट्री की ओर से, हम आपका समय और प्रयास देने के लिए दिल से धन्यवाद करते हैं। आपकी राय से शहर की सफाई और स्वच्छता में सुधार करने में मदद मिलेगी।",
    mlanguageId: 2,
    deleted: false
  },
  {
    langCode: "ta",
    langDisplay: "தமிழ்",
    langName: "Tamil",
    welcomeMessage:
      "\n இந்திய அரசின் வீட்டுவசதி மற்றும் நகர்ப்புற விவகார அமைச்சகம் (MoHUA), நாடு முழுவதும் உள்ள அனைத்து நகரங்களையும் உள்ளடக்கிய, ஆண்டு முழுவதும் செயல்படும் ஒரு குடிமக்கள் கருத்துப் பகிர்தல் வழிமுறையை செயல்படுத்தி வருகிறது. இந்த முயற்சியின் முக்கிய நோக்கம் தூய்மை மற்றும் சுகாதாரத்தை மேம்படுத்துவதில் குறிப்பாக உங்கள் வசிப்பிடத்தில் உங்கள் நகரம் அடைந்துள்ள முன்னேற்றம் குறித்த உங்கள் கருத்துக்களை  சேகரிப்பதாகும். உங்கள் கருத்துக்களைப் பகிர்ந்துகொள்வதற்காக நீங்கள் ஒதுக்கும் நேரத்தையும் எடுக்கும் முயற்சியையும், அமைச்சகத்தின் சார்பில் நாங்கள் உண்மையில் பாராட்டுகிறோம். உங்கள் மதிப்புமிக்க கருத்துக்கள் நகர்ப்புறத் தூய்மை முயற்சிகளை வலுப்படுத்துவதிலும் மேலும் தொடர் மேம்பாட்டை முன்னெடுத்துச் செல்வதிலும் முக்கியப் பங்காற்றும்.",
    mlanguageId: 3,
    deleted: false
  },
  {
    langCode: "as",
    langDisplay: "Assamese",
    langName: "Assamese",
    welcomeMessage:
      "ভাৰত চৰকাৰৰ গৃহ আৰু নগৰ পৰিক্ৰমা মন্ত্ৰালয়ে (MoHUA) সমগ্ৰ দেশৰ সকলো নগৰ চহৰক সামৰি লৈ বছৰজুৰি নাগৰিকৰ মতামত প্ৰদানৰ ব্যৱস্থা ৰূপায়ণ কৰি আছে। এই পদক্ষেপৰ এটা মূল উদ্দেশ্য হৈছে আপোনাৰ চহৰখনে বিশেষকৈ আপোনাৰ চুবুৰীত পৰিষ্কাৰ-পৰিচ্ছন্নতা আৰু অনাময় ব্যৱস্থা উন্নত কৰাৰ ক্ষেত্ৰত কৰা অগ্ৰগতিৰ ওপৰত আপোনাৰ মতামত সংগ্ৰহ কৰা। মন্ত্ৰালয়ৰ ফালৰ পৰা, আপোনাৰ মতামত ভাগ বতৰা কৰিবলৈ আপুনি লোৱা সময় আৰু প্ৰচেষ্টাক আমি আন্তৰিকতাৰে প্ৰশংসা কৰোঁ। আপোনাৰ মূল্যৱান ইনপুটসমূহে নগৰীয়া পৰিষ্কাৰ-পৰিচ্ছন্নতা পদক্ষেপসমূহক শক্তিশালী কৰা আৰু নিৰন্তৰ উন্নতি সাধনত এক গুৰুত্বপূৰ্ণ ভূমিকা পালন কৰিব।",
    mlanguageId: 4,
    deleted: false
  },
  {
    langCode: "bn",
    langDisplay: "Bengali",
    langName: "Bengali",
    welcomeMessage:
      "ভারত সরকারের হাউজিং ও আরবান বিষয়ক মন্ত্রক (MoHUA), এক বছর ধরে দেশের সমস্ত শহরের নাগরিকদের প্রতিক্রিয়া জানার ব্যবস্থা করছে। এই উদ্যোগের একটি মূল উদ্দেশ্য হলো—পরিচ্ছন্নতা ও স্যানিটেশন ব্যবস্থার উন্নয়নে, বিশেষ করে আপনার নিজ এলাকায়, আপনার শহরের অগ্রগতির বিষয়ে আপনার মতামত সংগ্রহ করা। মন্ত্রকের পক্ষ থেকে, আমরা আপনার প্রতিক্রিয়া দেওয়ার ব্যাপারে সময় নেওয়ার জন্য আপনাকে প্রশংসা জানাতে চাই। আপনার মূল্যবান মতামত শহরের পরিচ্ছন্নতার উদ্যোগকে শক্তিশালী করতে এবং ধারাবাহিক উন্নতির ধারা বজায় রাখতে গুরুত্বপূর্ণ ভূমিকা পালন করবে।",
    mlanguageId: 5,
    deleted: false
  },
  {
    langCode: "gu",
    langDisplay: "Gujarati",
    langName: "Gujarati",
    welcomeMessage:
      "ભારત સરકારના ગૃહ અને શહેરી બાબતોના મંત્રાલય (MoHUA) દ્વારા દેશભરના બધાજ અર્બન શહેરોને આવરી લેવામાં આવતા વર્ષભર નાગરિક ફીડબેક પદ્ધતિનો અમલ કરવામાં આવી રહ્યો છે. આ પહેલનો મુખ્ય હેતુ તમારા શહેર દ્વારા, ખાસ કરીને તમારા પડોશમાં, સ્વચ્છતા અને સ્વચ્છતાને સુધારવામાં થયેલી પ્રગતિ પર તમારો અભિપ્રાય એકત્રિત કરવાનો છે. મંત્રાલય વતી, અમે તમારા અભિપ્રાયો શેર કરવા માટે તમે જે સમય અને પ્રયાસ કરો છો તેની ખૂબજ પ્રશંસા કરીએ છીએ. તમારા મૂલ્યવાન સૂચનો શહેરી સ્વચ્છતા પહેલને મજબૂત બનાવવામાં અને સતત સુધારો કરવામાં મહત્વની ભૂમિકા ભજવશે.",
    mlanguageId: 6,
    deleted: false
  },
  {
    langCode: "mr",
    langDisplay: "Marathi",
    langName: "Marathi",
    welcomeMessage:
      "भारत सरकारच्या गृहनिर्माण आणि शहरी व्यवहार मंत्रालयाद्वारे (MoHUA), देशभरातील सर्व शहरांचा सहभाग असलेली वर्षभर चालणारी नागरिक प्रतिसाद यंत्रणा राबविण्यात येत आहे. तुमच्या शहराने, विशेषतः तुमच्या परिसरात, स्वच्छता आणि आरोग्य सुधारण्यासाठी केलेल्या प्रगतीबद्दल तुमचा अभिप्राय जाणून घेणे, हा या उपक्रमाचा मुख्य उद्देश आहे. मंत्रालयाच्या वतीने, तुमचे विचार मांडण्यासाठी तुम्ही दिलेल्या वेळेबद्दल आणि घेतलेल्या परिश्रमांबद्दल आम्ही तुमचे मनापासून आभार मानतो. तुमचे मौल्यवान अभिप्राय शहरी स्वच्छता उपक्रमांना अधिक बळकट करण्यात आणि सतत सुधारणा घडवून आणण्यात महत्त्वाची भूमिका बजावतील.",
    mlanguageId: 7,
    deleted: false
  },
  {
    langCode: "or",
    langDisplay: "Oriya",
    langName: "Oriya",
    welcomeMessage:
      "ଭାରତ ସରକାରଙ୍କ ଗୃହ ଏବଂ ସହରାଞ୍ଚଳ ବ୍ୟାପାର ମନ୍ତ୍ରଣାଳୟ (MoHUA) ଦେଶର ସମସ୍ତ ସହରାଞ୍ଚଳ ସହରକୁ କଭର କରି ଏକ ବର୍ଷବ୍ୟାପୀ ନାଗରିକ ମତାମତ ବ୍ୟବସ୍ଥା କାର୍ଯ୍ୟକାରୀ କରୁଛି। ଏହି ପଦକ୍ଷେପର ଏକ ମୁଖ୍ୟ ଉଦ୍ଦେଶ୍ୟ ହେଉଛି ଆପଣଙ୍କ ସହର ଦ୍ୱାରା ସ୍ୱଚ୍ଛତା ଏବଂ ପରିମଳ ଉନ୍ନତିରେ, ବିଶେଷକରି ଆପଣଙ୍କ ଚତୁରପାର୍ଶ୍ଵରେ  ହୋଇଥିବା ଅଗ୍ରଗତି ଉପରେ ଆପଣଙ୍କ ମତାମତ ସଂଗ୍ରହ କରିବା। ମନ୍ତ୍ରଣାଳୟ ପକ୍ଷରୁ, ଆପଣ ଆପଣଙ୍କର ମତାମତ ବାଣ୍ଟିବା ପାଇଁ ନେଉଥିବା ସମୟ ଏବଂ ପ୍ରୟାସକୁ ଆମେ ଆନ୍ତରିକ ଭାବରେ ପ୍ରଶଂସା କରୁଛୁ। ଆପଣଙ୍କ ମୂଲ୍ୟବାନ ମତାମତ ସହରାଞ୍ଚଳ ସ୍ୱଚ୍ଛତା ପଦକ୍ଷେପକୁ ସୁଦୃଢ଼ କରିବା ଏବଂ ନିରନ୍ତର ଉନ୍ନତି ଆଣିବାରେ ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ଭୂମିକା ଗ୍ରହଣ କରିବ।",
    mlanguageId: 8,
    deleted: false
  },
  {
    langCode: "pa",
    langDisplay: "Punjabi",
    langName: "Punjabi",
    welcomeMessage:
      "ਭਾਰਤ ਸਰਕਾਰ ਦਾ ਆਵਾਸ ਅਤੇ ਸ਼ਹਿਰੀ ਮਾਮਲਿਆਂ ਦਾ ਮੰਤਰਾਲਾ (MoHUA), ਦੇਸ਼ ਭਰ ਦੇ ਸਾਰੇ ਸ਼ਹਿਰੀ ਸ਼ਹਿਰਾਂ ਨੂੰ ਕਵਰ ਕਰਨ ਵਾਲਾ ਇੱਕ ਸਾਲ ਭਰ ਚੱਲਣ ਵਾਲਾ ਨਾਗਰਿਕ ਫੀਡਬੈਕ ਵਿਧੀ ਲਾਗੂ ਕਰ ਰਿਹਾ ਹੈ। ਇਸ ਪਹਿਲਕਦਮੀ ਦਾ ਇੱਕ ਮੁੱਖ ਉਦੇਸ਼ ਤੁਹਾਡੇ ਸ਼ਹਿਰ ਦੁਆਰਾ ਸਫਾਈ ਅਤੇ ਸੈਨੀਟੇਸ਼ਨ ਨੂੰ ਬਿਹਤਰ ਬਣਾਉਣ ਵਿੱਚ ਕੀਤੀ ਗਈ ਪ੍ਰਗਤੀ ਬਾਰੇ ਤੁਹਾਡੀ ਫੀਡਬੈਕ ਇਕੱਠੀ ਕਰਨਾ ਹੈ, ਖਾਸ ਕਰਕੇ ਤੁਹਾਡੇ ਆਂਢ-ਗੁਆਂਢ ਵਿੱਚ। ਮੰਤਰਾਲੇ ਵੱਲੋਂ, ਅਸੀਂ ਤੁਹਾਡੇ ਵਿਚਾਰ ਸਾਂਝੇ ਕਰਨ ਲਈ ਤੁਹਾਡੇ ਦੁਆਰਾ ਦਿੱਤੇ ਗਏ ਸਮੇਂ ਅਤੇ ਯਤਨਾਂ ਦੀ ਦਿਲੋਂ ਕਦਰ ਕਰਦੇ ਹਾਂ। ਤੁਹਾਡੇ ਕੀਮਤੀ ਇਨਪੁਟ ਸ਼ਹਿਰੀ ਸਫਾਈ ਪਹਿਲਕਦਮੀਆਂ ਨੂੰ ਮਜ਼ਬੂਤ ​​ਕਰਨ ਅਤੇ ਨਿਰੰਤਰ ਸੁਧਾਰ ਨੂੰ ਅੱਗੇ ਵਧਾਉਣ ਵਿੱਚ ਮਹੱਤਵਪੂਰਨ ਭੂਮਿਕਾ ਨਿਭਾਉਣਗੇ।",
    mlanguageId: 9,
    deleted: false
  },
  {
    langCode: "te",
    langDisplay: "Telugu",
    langName: "Telugu",
    welcomeMessage:
      "భారత ప్రభుత్వ గృహ మరియు పట్టణ వ్యవహారాల మంత్రిత్వ శాఖ (MoHUA), దేశవ్యాప్తంగా ఉన్న అన్ని పట్టణ నగరాలను కవర్ చేస్తూ, ఏడాది పొడవునా పౌరుల అభిప్రాయ సేకరణ యంత్రాంగాన్ని అమలు చేస్తోంది. ఈ కార్యక్రమం యొక్క ముఖ్య ఉద్దేశ్యం, ముఖ్యంగా మీ పరిసర ప్రాంతాలలో, పరిశుభ్రత మరియు పారిశుధ్యం మెరుగుపరచడంలో మీ నగరం సాధించిన పురోగతిపై మీ అభిప్రాయాన్ని సేకరించడం. మీ అభిప్రాయాలను పంచుకోవడానికి మీరు వెచ్చించే సమయాన్ని, కృషిని మంత్రిత్వ శాఖ తరపున మేము హృదయపూర్వకంగా అభినందిస్తున్నాము. పట్టణ పరిశుభ్రత కార్యక్రమాలను బలోపేతం చేయడంలో మరియు నిరంతర అభివృద్ధిని సాధించడంలో మీ విలువైన సూచనలు కీలక పాత్ర పోషిస్తాయి.",
    mlanguageId: 10,
    deleted: false
  },
  {
    langCode: "ka",
    langDisplay: "Kannada",
    langName: "Kannada",
    welcomeMessage:
      "ಭೂಮಿಪೂರ್ವ ನಿವಾಸ ಮತ್ತು ನಗರ ವ್ಯವಹಾರಗಳ ಮಂತ್ರಾಲಯ (MoHUA), ಭಾರತ ಸರ್ಕಾರ, ದೇಶದ ಎಲ್ಲಾ ನಗರಗಳಲ್ಲಿ ವರ್ಷಪೂರ್ತಿ ನಾಗರಿಕ ಅಭಿಪ್ರಾಯ ಸಂಗ್ರಹಣಾ ವ್ಯವಸ್ಥೆಯನ್ನು ಅನುಷ್ಠಾನಗೊಳಿಸುತ್ತಿದೆ. ಈ ಪ್ರಯತ್ನದ ಮುಖ್ಯ ಉದ್ದೇಶವು ನಿಮ್ಮ ನಗರವು ಸ್ವಚ್ಚತೆ ಮತ್ತು ಸಾರ್ವಜನಿಕ ಪರಿಚ್ಛೇದನೆಯಲ್ಲಿ ಸಾಧಿಸಿರುವ ಪ್ರಗತಿಯನ್ನು ತಿಳಿದುಕೊಳ್ಳಲು, ವಿಶೇಷವಾಗಿ ನಿಮ್ಮ ನೆರೆಹೊರೆಯಲ್ಲಿ, ನಿಮ್ಮ ಅಭಿಪ್ರಾಯವನ್ನು ಸಂಗ್ರಹಿಸುವುದಾಗಿದೆ. ಮಂತ್ರಾಲಯದ ಪರವಾಗಿ, ನಿಮ್ಮ ಅಭಿಪ್ರಾಯವನ್ನು ಹಂಚಲು ನೀವು ನೀಡುವ ಸಮಯ ಮತ್ತು ಪ್ರಯತ್ನಕ್ಕೆ ನಾವು ಹೃತ್ಪೂರ್ವಕ ಧನ್ಯವಾದಗಳನ್ನು ತಿಳಿಸುತ್ತೇವೆ. ನಿಮ್ಮ ಅಮೂಲ್ಯವಾದ ಫೀಡ್‌ಬ್ಯಾಕ್ ನಗರ ಸ್ವಚ್ಚತಾ ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ಬಲಪಡಿಸಲು ಮತ್ತು ನಿರಂತರ ಸುಧಾರಣೆಯನ್ನು ಮುಂದುವರಿಸಲು ಪ್ರಮುಖ ಪಾತ್ರ ವಹಿಸುತ್ತದೆ.",
    mlanguageId: 11,
    deleted: false
  },
  {
    langCode: "ur",
    langDisplay: "Urdu",
    langName: "Urdu",
    welcomeMessage:
      "ہاؤسنگ اور شہری امور کی وزارت (MoHUA)، حکومت ہند، پورے ملک کے تمام شہری علاقوں میں ایک سال بھر کے شہری فیڈ بیک سسٹم کو نافذ کر رہی ہے۔ اس اقدام کا بنیادی مقصد آپ کے شہر، خاص طور پر آپ کے پڑوس میں صفائی ستھرائی میں بہتری کے بارے میں آپ کی رائے جمع کرنا ہے۔ وزارت کی جانب سے، ہم آپ کے وقت اور کوشش کے لیے آپ کا تہہ دل سے شکریہ ادا کرتے ہیں۔ آپ کے تاثرات سے شہر کی صفائی ستھرائی کو بہتر بنانے میں مدد ملے گی۔",
    mlanguageId: 12,
    deleted: false
  },
  {
    langCode: "ml",
    langDisplay: "Malayalam",
    langName: "Malayalam",
    welcomeMessage:
      "ഇന്ത്യാ ഗവണ്‍മെന്‍റിന്റെ  ഭവന, നഗരകാര്യ മന്ത്രാലയം (MoHUA), രാജ്യത്തുടനീളമുള്ള എല്ലാ അബന്‍  നഗരങ്ങളെയും ഉൾപ്പെടുത്തി വർഷം മുഴുവനും പൗര ഫീഡ്‌ബാക്ക് സംവിധാനം നടപ്പിലാക്കുന്നു. ഈ സംരംഭത്തിന്റെ ഒരു പ്രധാന ലക്ഷ്യം, പ്രത്യേകിച്ച് നിങ്ങളുടെ അയൽപക്കത്ത്, ശുചിത്വവും സാനിറ്റേഷനും  മെച്ചപ്പെടുത്തുന്നതിൽ നിങ്ങളുടെ നഗരം കൈവരിച്ച പുരോഗതിയെക്കുറിച്ചുള്ള നിങ്ങളുടെ ഫീഡ്‌ബാക്ക് ശേഖരിക്കുക എന്നതാണ്. നിങ്ങളുടെ അഭിപ്രായങ്ങൾ പങ്കുവെക്കാൻ നിങ്ങൾ എടുക്കുന്ന സമയത്തിനും പരിശ്രമത്തിനും മന്ത്രാലയത്തിനു വേണ്ടി ഞങ്ങൾ ആത്മാർത്ഥമായി നന്ദി പറയുന്നു. നഗര ശുചിത്വ സംരംഭങ്ങൾ ശക്തിപ്പെടുത്തുന്നതിലും തുടർച്ചയായ പുരോഗതി കൈവരിക്കുന്നതിലും നിങ്ങളുടെ വിലയേറിയ അഭിപ്രായങ്ങൾ ഒരു പ്രധാന പങ്ക് വഹിക്കും.",
    mlanguageId: 13,
    deleted: false
  }
];

export default languages;
